import React from 'react';
import { FormattedMessage } from 'react-intl';

import messages from './messages';
import './styles.css';

const NoResults = () => (
  <div className="rep-visits-ratings">
    <p styleName="no-ratings-text">
      <FormattedMessage {...messages.noRatings} />
    </p>
  </div>
);

export default NoResults;
